(function () {
  'use strict';
  function isVisible(field, state, byId, visiting = new Set()) {
    if (visiting.has(field.id)) return false;
    const chain = new Set(visiting).add(field.id);
    return (field.conditions || []).every((rule) => {
      const controller = byId.get(rule.field);
      return controller && isVisible(controller, state, byId, chain) && rule.choices.includes(state[rule.field]);
    });
  }
  function configurationKey(config, state) {
    const byId = new Map(config.fields.map((field) => [field.id, field]));
    const choices = config.pricedFieldIds.map((id) => {
      const field = byId.get(id);
      return isVisible(field, state, byId) ? (state[id] || '') : '~';
    });
    if (choices.some((choice) => choice === '')) return null;
    if (config.lookupMode === 'price') {
      let price = config.basePriceCents;
      for (let index = 0; index < choices.length; index++) {
        if (choices[index] === '~') continue;
        const option = byId.get(config.pricedFieldIds[index]).options.find((item) => item.id === choices[index]);
        if (!option) return null;
        price += option.priceCents;
      }
      return String(price);
    }
    return choices.join('|');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { isVisible, configurationKey };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('amazon-pillow-customization')) return;

  class AmazonPillowCustomization extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = document.getElementById(this.dataset.form);
      const script = this.querySelector('[data-pillow-config]');
      if (!this.form || !script) return;
      try { this.config = JSON.parse(script.textContent); } catch (_) { return; }
      if (!this.config?.fields?.length || !Object.keys(this.config.variantLookup || {}).length) return;
      this.initialized = true;
      this.state = {};
      this.byId = new Map(this.config.fields.map((field) => [field.id, field]));
      this.nodes = new Map();
      this.section = this.closest('.amazon-pillow');
      this.price = this.section.querySelector('[data-pillow-price]');
      this.status = this.querySelector('[data-pillow-status]');
      this.idInput = this.form.querySelector('[data-pillow-variant]');
      this.addButton = this.form.querySelector('[data-pillow-add]');
      this.money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.config.currency }).format(cents / 100);
      this.render();
      this.onEdit = (event) => {
        const id = event.target.dataset.pillowField;
        if (!id) return;
        this.state[id] = event.target.value;
        this.update();
      };
      this.addEventListener('change', this.onEdit);
      this.addEventListener('input', this.onEdit);
      this.onSubmit = (event) => {
        this.update();
        if (this.addButton.disabled || !this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalid = [...this.nodes.values()].find(({ control }) => !control.disabled && !control.checkValidity());
          invalid?.control.focus();
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.onImage = (event) => {
        const button = event.target.closest('[data-pillow-image]');
        if (!button) return;
        const image = this.section.querySelector('[data-pillow-main-image]');
        image.src = button.dataset.pillowImage;
        image.alt = button.dataset.imageAlt || this.config.design;
        this.section.querySelectorAll('[data-pillow-image]').forEach((node) => node.setAttribute('aria-pressed', String(node === button)));
      };
      this.section.addEventListener('click', this.onImage);
      this.update();
      this.dataset.ready = 'true';
    }
    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    render() {
      const container = this.querySelector('[data-pillow-fields]');
      for (const surface of this.config.surfaces || []) {
        if (surface.label) container.append(this.element('h2', 'amazon-pillow__surface', surface.label));
        if (surface.instructions) container.append(this.element('p', 'amazon-pillow__surface-instructions', surface.instructions));
      }
      for (const field of this.config.fields) {
        const wrapper = this.element('div', 'amazon-pillow__field');
        wrapper.dataset.fieldId = field.id;
        const label = this.element('label', 'amazon-pillow__label', field.label + (field.required ? ' *' : ''));
        const control = this.element(field.type === 'select' ? 'select' : field.maxLines > 1 ? 'textarea' : 'input', 'amazon-pillow__control');
        control.id = `Pillow-${this.dataset.section}-${field.id}`;
        control.dataset.pillowField = field.id;
        control.setAttribute('form', (["B0CW5XGYJJ","B0FVLQ3V9Z","B0HMRNLR1L","B0HMCKW477"].includes(this.config.sourceListingAsin)?this.dataset.form:this.form.id));
        label.htmlFor = control.id;
        wrapper.append(label);
        if (field.type === 'select') {
          control.append(new Option('Select...', ''));
          for (const option of field.options) {
            const suffix = option.priceCents ? ` (+${this.money(option.priceCents)})` : '';
            control.append(new Option(option.label + suffix, option.id));
          }
        } else {
          if (control.tagName === 'INPUT') control.type = 'text';
          control.minLength = field.minLength;
          control.maxLength = field.maxLength;
          control.placeholder = field.placeholder || '';
          control.autocomplete = 'off';
          control.setAttribute('data-1p-ignore', 'true');
          if (field.pattern && control.tagName === 'INPUT') control.pattern = field.pattern;
        }
        wrapper.append(control);
        const property = this.element('input');
        property.type = 'hidden';
        property.name = `properties[${field.label}]`;
        property.setAttribute('form', (["B0CW5XGYJJ","B0FVLQ3V9Z","B0HMRNLR1L","B0HMCKW477"].includes(this.config.sourceListingAsin)?this.dataset.form:this.form.id));
        wrapper.append(property);
        let counter = null;
        if (field.type === 'text') {
          counter = this.element('p', 'amazon-pillow__counter');
          wrapper.append(counter);
        }
        if (field.instructions) {
          const instructions = this.element('p', 'amazon-pillow__instruction', field.instructions);
          instructions.id = control.id + '-instructions';
          control.setAttribute('aria-describedby', instructions.id);
          wrapper.append(instructions);
        }
        const image = this.element('img', 'amazon-pillow__option-image');
        image.hidden = true;
        image.loading = 'lazy';
        wrapper.append(image);
        container.append(wrapper);
        this.nodes.set(field.id, { wrapper, control, property, counter, image });
      }
    }
    update() {
      let complete = true;
      for (const field of this.config.fields) {
        const visible = isVisible(field, this.state, this.byId);
        const { wrapper, control, property, counter, image } = this.nodes.get(field.id);
        wrapper.hidden = !visible;
        control.disabled = !visible;
        control.required = visible && field.required;
        property.disabled = !visible;
        if (!visible) {
          this.state[field.id] = '';
          control.value = '';
          property.value = '';
        } else {
          const choice = field.type === 'select' ? field.options.find((option) => option.id === control.value) : null;
          property.value = choice ? choice.label : control.value;
          image.hidden = !choice?.image;
          if (choice?.image) { image.src = choice.image; image.alt = choice.label; }
          if (counter) counter.textContent = `${control.value.length} / ${field.maxLength} characters`;
          control.setCustomValidity('');
          if (field.type === 'text' && control.value.length > field.maxLength) control.setCustomValidity(`Please use no more than ${field.maxLength} characters.`);
          if (this.config.sourceListingAsin === 'B0HMCKW477' && field.type === 'text') {
            if (field.maxLines && control.value.split(/\r\n|\r|\n/).length > field.maxLines) control.setCustomValidity(`Please use no more than ${field.maxLines} lines.`);
            if (field.pattern && !(new RegExp('^(?:' + field.pattern + ')$')).test(control.value)) control.setCustomValidity('Please match the source text format.');
          }
          if (!control.checkValidity()) complete = false;
        }
      }
      const key = configurationKey(this.config, this.state);
      const variant = key && this.config.variantLookup[key];
      this.idInput.disabled = !variant;
      this.idInput.value = variant ? variant.id : '';
      this.addButton.disabled = !complete || !variant;
      this.status.textContent = complete && variant ? 'Your personalization is ready. Please check the details before adding to cart.' : 'Choose your options and enter the required details.';
      if (variant) this.price.textContent = this.money(variant.priceCents) + ' ' + this.config.currency;
      else this.price.textContent = 'From ' + this.money(this.config.basePriceCents) + ' ' + this.config.currency;
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onEdit);
      this.removeEventListener('input', this.onEdit);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.section?.removeEventListener('click', this.onImage);
      this.initialized = false;
    }
  }
  customElements.define('amazon-pillow-customization', AmazonPillowCustomization);
})();
